module.exports = __webpack_public_path__ + "img/carousel-2.cb03594e.jpg";